import classnames from 'classnames';
import React, { useRef } from 'react';
import styles from './styles.module.less';

const SizeAction = () => {
    const horizontalControlCursorNodeRef = useRef<HTMLSpanElement>(null);
    const verticalControlCursorNodeRef = useRef<HTMLSpanElement>(null);

    const backSlashCursorArr = [3, 0, 1, 2];

    return (
        <div className="l-cropStage-sizeAction">
            <span ref={verticalControlCursorNodeRef}>
                <div
                    className={classnames('resize tc', {
                        [styles[`scale-${backSlashCursorArr[1]}`]]: true,
                    })}
                    data-type="crop-tc"
                />
                <div
                    className={classnames('resize bc', {
                        [styles[`scale-${backSlashCursorArr[1]}`]]: true,
                    })}
                    data-type="crop-bc"
                />
            </span>

            <span ref={horizontalControlCursorNodeRef}>
                <div
                    className={classnames('resize lc', {
                        [styles[`scale-${2}`]]: true,
                    })}
                    data-type="crop-lc"
                />
                <div
                    className={classnames('resize rc', {
                        [styles[`scale-${2}`]]: true,
                    })}
                    data-type="crop-rc"
                />
            </span>
        </div>
    );
};

export default SizeAction;
